import { withStyles, TextField } from '@material-ui/core'

const TextFieldAlba = withStyles(() => ({
  root: {
    backgroundColor: 'white',
    marginBottom: '10px',
  },
}))(TextField)

export default TextFieldAlba
